import h from "./htm";
import uuid from "./uuid";

export default ({label='', required=false, type='', key='', value='', max, options, children, def, attrs, accept, countries, invalidMessage}) => {
	const 	uniqueId = uuid('f-'),
			labelDef = `label for="${uniqueId}"`,
			labelStr = label + (required ? h('sup','*') : '');

	if(type === 'break') return '<hr>';


	function getSelectCountries() {
		const container = document.createElement('div');

		const sel = document.createElement('select');	
		sel.setAttribute('id', uniqueId);
		sel.setAttribute('name', key);

		if(required){
			sel.classList.add('validate');
			sel.setAttribute('validate', 'onsubmit');
			sel.setAttribute('requiredtype', 'sel');
			sel.setAttribute('invalidmessage', invalidMessage);
		}

		const defaultOption = document.createElement('option');
		defaultOption.text = label;
		defaultOption.setAttribute('disabled', 'disabled');
		defaultOption.setAttribute('selected', 'selected');	
		defaultOption.setAttribute('selected', 'selected');
		defaultOption.setAttribute('value', '');

		sel.add(defaultOption);

		for(let i = 0, l = countries.length; i < l; i++){
			const option = document.createElement('option');
			option.setAttribute('value', countries[i].code);
			option.text = countries[i].name;
			sel.add(option);
		}
		
		container.appendChild(sel);

		const html = container.innerHTML;

		return html;
	}

	function getTextRequired(requiredType){
		const container = document.createElement('div');

		const lbl = document.createElement('label');
		lbl.setAttribute('for', uniqueId);
		lbl.innerHTML = `${label}<sup>*</sup>`;

		container.appendChild(lbl);

		const textBox = document.createElement('input');
		textBox.setAttribute('id', uniqueId);
		textBox.setAttribute('name', key);
		textBox.setAttribute('type', requiredType);
		textBox.setAttribute('validate', 'onsubmit');
		textBox.setAttribute('requiredtype', requiredType);
		textBox.setAttribute('invalidmessage', invalidMessage);

		container.appendChild(textBox);
		
		const html = container.innerHTML;

		return html;
	}

	return h('div field', (() => {
		switch(type){
			case 'email-required':
				return getTextRequired('email');

			case 'select-countries':
				return getSelectCountries();

			case 'text-required':
				return getTextRequired('text');

			case 'text':
			case 'email':
			case 'number':
			case 'tel':
			case 'hidden':
				return h(labelDef,labelStr)
				('input id="'+uniqueId+'" name="'+key+'" type="'+type+'" '+(type === 'tel' ? 'pattern="^(\\([0-9]{3}\\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$"' : '') + (max === undefined ? '' : ' maxlength="'+max+'"') + ' class="'+(required ? 'validate' : '')+'" value="'+(value || '')+'"');
			case 'textarea':
				return h(labelDef,labelStr)
				('textarea id="'+uniqueId+'" name="'+key+'" class="'+(required ? 'validate' : '')+'" ' + (max === undefined ? '' : 'maxlength="'+max+'"') );
			case 'select':
				return h(labelDef + ' style="display: none;"',labelStr)
					('select id="'+uniqueId+'" name="'+key+'" class="'+(required ? 'validate' : '')+'" ' + (children ? ' children="' + children + '"' : ''),
					h(label ? 'option value="" disabled selected' : '',label) + 
					(typeof options === 'string' ? options.split(',') : options || []).reduce((html,optionItem) => {
						return html + (typeof optionItem === 'string' ? h('option value="'+optionItem+'"',optionItem) : h('option value="'+optionItem.label+'" '+(optionItem.children ? children.split(',').reduce((str,childItem) => {
							return str + ' ' + childItem + '="' + optionItem.children[childItem] + '"';
						},'') : '')+'',optionItem.label));
					},'')
				);
			case 'check':
			case 'radio':
				return h('input type="'+(type === 'check' ? 'checkbox' : 'radio')+'" class="filled-in ' + (required ? 'validate' : '') + '" id="'+uniqueId+'" name="'+key+'" value="'+(value || 'on')+'"' + ' ' + (attrs || '') + ' ')
				(labelDef,labelStr)
				(def ? 'label def for="'+uniqueId+'"' : '',def);
			case 'file':
				return h(labelDef,labelStr)
				('input id="'+uniqueId+'" name="'+key+'" type="'+type+'" accept="'+(accept || '')+'" class="'+(required ? 'validate' : '')+'"');
			default:
				return '';
		}
	})());
};